

/**
 * Helper genérico para requisições da área de jogador.
 * Envia o token de sessão automaticamente via cookies ou header,
 * conforme implementado no backend/authApi.
 */
async function req<T>(token: string, endpoint: string, options: RequestInit = {}): Promise<T> {
  const url = `/api${endpoint}`;

  const res = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      ...options.headers,
    },
  });

  if (!res.ok) {
    let errorMsg = `HTTP ${res.status}`;
    try {
      const errData = await res.json() as { error?: string };
      if (errData.error) errorMsg = errData.error;
    } catch {
      // Ignora erro de JSON
    }
    throw new Error(errorMsg);
  }

  // Verifica Content-Type
  const contentType = res.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    return (await res.json()) as T;
  }

  return {} as T;
}

export interface PlayerRankEntry {
  rank: number;
  id: string;
  name: string;
  class: string;
  totalPoints: number;
  wins: number;
  losses: number;
  isMe: boolean;
}

export interface RankingResponse {
  leaderboard: PlayerRankEntry[];
  totalItems: number;
  page: number;
  limit: number;
  showAll: boolean;
  adminLimit: number | null;
}

export const playerApi = {
  getRanking: (token: string, page = 1, limit = 50) => 
    req<RankingResponse>(token, `/ranking?page=${page}&limit=${limit}`),
};
